import React from 'react';
import { Box, Divider } from '@mui/material';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { FileBrowserButtons } from './FileBrowserButtons';
import { FilesDataGrid } from './FilesDataGrid';
import { PrefixSelector } from './PrefixSelector';

interface Props {
  subtitle: string;
}

const boxSx = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "93%",
};

export const FileBrowserPanel: React.FC<Props> = ({
  subtitle,
}) => {
  return (
    <Box component="div" sx={{ height: '100%', width: '100%' }}>

      <Box component="div" sx={{ display: 'flex', alignItems: 'center', height: '5%' }}>
        <CustomTypography >{subtitle}</CustomTypography>
      </Box>

      <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

      <Box component="div" sx={boxSx}>
        <Box component="div" position="sticky" top={0} width="100%" zIndex={1} paddingBottom={1}>
          <PrefixSelector />
          <FileBrowserButtons />
        </Box>
        <Box component="div" flexGrow={1} overflow="auto">
          <FilesDataGrid />
        </Box>
      </Box>

    </Box >
  );
};
